angular
	.module 'App.Module.Product', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'products',
				url: '/inventory/products',
				abstract: true
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@products':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'ProductSearchController'
						controllerAs: 'search'
				data:
					searchParams:
						repositoryName: 'ProductRepository'
						title: 'general.products'
						labelTemplate: '@app/product/product.search-result-label.view.html'
						advanced:
							configuration: SEARCH_CONFIGURATION.products
						createEnabled: ->
							return @ConfigurationService.isEnabled('Backoffice.ProductManagement.Products.EnableProductCreation')
					restrict: 'Backoffice.TopMenu.Inventory.Products'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					priceRegions: (PriceRegionRepository) ->
						PriceRegionRepository.getEntities()
					reasonCodes: (ReasonCodeRepository) ->
						return ReasonCodeRepository.getEntities()
					vatRates: (VatRateRepository, ConfigurationService) ->
						if ConfigurationService.isEnabled 'Shared.Setting.VatRate.Enabled'
							return VatRateRepository.getEntities()
						return []
					units: (UnitRepository) ->
						return UnitRepository
							.getEntities()
							.then (units) ->
								return _.indexBy units, 'id'
					stockLocations: (StockLocationRepository) ->
						return StockLocationRepository.getEntities()
					productFilters: (ProductFilterRepository) ->
						return ProductFilterRepository
							.getEntities()
							.then (productFilters) ->
								return _.indexBy productFilters, 'id'
					suppliers: (SuppliersRepository) ->
						return SuppliersRepository.getEntities()

			.state 'products.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					product: ($stateParams, ProductRepository, ProductRelationsLoadingService) ->
						query = ProductRepository.createQuery()
						query.with 'product_variants',
							{property: 'product_categories', type: 'id'}
							{property: 'addon_products', type: 'id'}
							{property: 'bundled_products', type: 'id'}
							{property: 'shops', type: 'id'}
							{property: 'shop_groups', type: 'id'}
							{property: 'product_suggestions', type: 'id'}

						return ProductRepository
							.getEntity($stateParams.id, query)
							.then (product) =>
								if !product? || _.isEmpty(product)
									return {}

								return ProductRelationsLoadingService.loadRelations(product)
					stockValues: ($stateParams, StockValueRepository) ->
						if !_.isEmpty $stateParams.id
							query = StockValueRepository.createQuery()
							query.criteria 'product_id', '=', $stateParams.id
							query.criteria 'product_variant.delete_time', 'IS', 'NULL'

							return StockValueRepository.getEntities(query)
						return []
					isInABundle: (product, BundledProductMetadataRepository) ->
						if !product? || _.isEmpty(product)
							return false

						query = BundledProductMetadataRepository.createQuery()
						query.criteria('product_id', '=', product.id)

						return BundledProductMetadataRepository
							.countEntities(query)
							.then (count) -> count > 0
			.state 'products.edit.details',
				url: '/details'
				views:
					entity_sub_view:
						controller: 'ProductController'
						controllerAs: 'vm'
						templateUrl: '@app/product/product.view.html'
